import React from 'react'
import ContentLoader from 'react-content-loader'

const LoaderItemsDocuments = ({ isMobile, ...rest }) => {
  const viewBox = isMobile ? "0 0 280 75" : "0 0 800 75";
  return (
    <ContentLoader viewBox={viewBox} height={75} width={isMobile ? 280 : 800} {...rest}>
      <rect x="90" y="16" rx="5" ry="5" width="321" height="15" />
      <rect x="129" y="39" rx="5" ry="5" width="220" height="9" />
      <rect x="26" y="10" rx="0" ry="0" width="50" height="45" />
    </ContentLoader>
  )
}

export default LoaderItemsDocuments
